import React, {useContext, useRef} from 'react';
import Context from '../OriginStoryProvider';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const AnimatedSeals = () => {
	const { data: {content} } = useContext(Context);

	const animatedSeals = useRef(null);
	const animatedSealsContainer = useRef(null);

	useGSAP(() => {
		const seals = gsap.utils.toArray('.chapter-1__animated-seals__seal');
		const tl = gsap.timeline()
			.to('.chapter-1__animated-seals__image', {
				opacity: (index) => {
					if (index !== 0) {
						return 1;
					}
				},
				stagger: 2.5,
				duration: 1,
			})
			.from('.chapter-1__animated-seals__year', {
				opacity: (index) => {
					if (index === 0) {
						return;
					} else {
						return 0;
					}
				},
				stagger: 2.5,
			}, '<')
			.to('.chapter-1__animated-seals__year', {
				opacity: (index) => {
					if (index === (seals.length - 1)) {
						return;
					} else {
						return 0;
					}
				},
				stagger: 2.5,
				delay: 1,
			}, '<1')

		ScrollTrigger.create({
			trigger: animatedSealsContainer.current,
			start: 'center center',
			pin: true,
			scrub: 2,
			animation: tl,
		});
	}, {scope:animatedSeals.current, dependencies: [content.chapters]});

	return (
		<div className='chapter-1__animated-seals' ref={animatedSeals}>
			<div className='chapter-1__animated-seals__container main-grid' ref={animatedSealsContainer}>
				<div className='main-grid__margin'></div>
				<div className='main-grid__body'>
					<ul className='chapter-1__animated-seals__year-container'>
						{
							content.chapters.first.animated_seals.map((seal) => {
								return (
									<li key={seal.year} className='chapter-1__animated-seals__year'>
										<p className='chapter-1__animated-seals__year-text'>{seal.year}</p>
									</li>
								)
							})
						}
					</ul>
					<ul className='chapter-1__animated-seals__seals'>
						{
							content.chapters.first.animated_seals.map((seal) => {
								return (
									<li key={seal.year} className='chapter-1__animated-seals__seal'>
										<div className='aspect-ratio-box'>
											<img className='chapter-1__animated-seals__image' src={`${mainScript.assetPath}images/png/seal-${seal.year}.png`} alt={seal.alt} loading="lazy"/>
										</div>
									</li>
								)
							})
						}
					</ul>
				</div>
				<div className='main-grid__margin'></div>
			</div>
		</div>
	)
}

export default AnimatedSeals;